import Controller, { OnClick } from '@philips-internal/oswald-ui-core/lib/client';
import { Inject } from '@odinjs/odin';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Endpoint } from '../../constants/endpoints';
import BaseController from '../BaseController';
import { ApplicationRoute } from '../../constants/routes';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { PanelAPI } from '@philips-internal/oswald-ui-components';

interface PatientEvolutionData {
  EvolutionPatientText: string;
}

@Controller({ component: 'layout-patient-evolution-delete', fragment: 'patient-evolution-delete' })
class EvolutionPatientController extends BaseController {

  @Inject('panel-action')
  painelAction!: PanelAPI;

  @Inject('panel-delete')
  painelDelete!: PanelAPI;

  patientEvolutionResponse = {};

  @OnClick({ target: ['delete-notnow-btn'] })
  onClickCancel(): void {
    const { cdEvolucao, patientId, encounterId } = this.historyService.getCurrentRouteParams();
    const eStatus = 'P';
    applicationContext.redirect(ApplicationRoute.CLINICAL_NOTES_EDIT, {
      cdEvolucao,
      encounterId,
      eStatus,
      patientId,
    });
  }

  @OnClick({ target: ['patient-evolution-delete-submit'] })
  onClickSubmitDelete(): void {
    this.painelDelete.setVisible(false);
    this.painelAction.setVisible(true)
  }

  @OnClick({ target: ['delete-confirm-btn'] })
  onClickRelease(): void {

    const { cdEvolucao, patientId, encounterId } = this.historyService.getCurrentRouteParams();
    HttpService.delete(Endpoint.PATIENT_EVOLUTION, { cdEvolucao }).then(data => {
      this.patientEvolutionResponse = data.body as PatientEvolutionData;
      applicationContext.redirect(ApplicationRoute.ELECTRONIC_PATIENT_CHART +
        ApplicationRoute.PATIENT_LIST +
        ApplicationRoute.CLINICAL_NOTES_LIST, {
        encounterId,
        patientId,
      });
    });
  }
}

export default EvolutionPatientController;
